"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Skeleton_1 = __importDefault(require("@mui/material/Skeleton"));
var MuiContainer_1 = __importDefault(require("../utilComponents/MuiContainer"));
function SkeletonLoader(props) {
    var width = props.width, height = props.height, _a = props.variant, variant = _a === void 0 ? 'text' : _a, children = props.children;
    return (react_1.default.createElement(MuiContainer_1.default, null,
        react_1.default.createElement(Skeleton_1.default, { variant: variant, width: width, height: height }, children)));
}
exports.default = SkeletonLoader;
